/* eslint-disable @typescript-eslint/no-explicit-any */
import { type AccessInfo } from '@/typings/user';

export default function access(initialState: { currentUser?: AccessInfo }) {
  const { accessRoutes, roles, id } = initialState?.currentUser ?? {};

  return {
    routeFilter: ({ path }: { path: string }) => {
      let fixedPath: string = path;
      const dynamicStartIndex = path.indexOf('/:');
      // 处理动态路由，截掉末尾动态部分
      if (dynamicStartIndex !== -1) {
        fixedPath = path.slice(0, dynamicStartIndex);
      }
      return accessRoutes?.includes(fixedPath);
    },
    // 所属BV业务单元 才有的权限
    reportRouteFilter: () => accessRoutes?.includes('/analysis/report'),
    // 用户是否是柏俊玲
    isBai: id == 124,
    isOp: roles?.includes(12),
    // 内控
    isRm: roles?.includes(3),
    // Google运营负责人
    isGm: roles?.includes(13),
    // 可以更新账单的AE
    isGmAe: roles?.includes(22),
    // AE
    isAe: roles?.includes(1),
    // 商务 tt商务 & 小媒体商务
    isBus: roles?.includes(20) || roles?.includes(21),
    // 查看全部申请的特殊AE 待审批页面不能操作
    isTAe: roles?.includes(24),
    isAdmin: roles?.includes(5),
    isSelf: (val: number) => id === val,
    isSaleLeader: roles?.indexOf(2) === -1 || roles?.indexOf(9) !== -1,
    isDn: id === 121,
    // 知识中心文件夹下
    knowledgeRouteFilter: ({ path }: any) =>
      accessRoutes?.includes(path.substring(0, path.lastIndexOf('/'))),
    // 东南亚AE 拥有`媒体消耗导入`权限
    isVeAe: roles?.includes(27),
    // SMB 销售
    isSmbSale: roles?.includes(33),
    // AE-到账提现
    isWithdrawAe: roles?.includes(34),
    // SMB AE
    isSmbAe: roles?.includes(22),
    // 运营policy
    isPolicy: roles?.includes(14),
    // tt商务
    isTtOp: roles?.includes(20),
    // 东南亚商务
    isSoutheastOp: roles?.includes(43),
  };
}
